import React, { Component } from 'react';
import { connect } from 'react-redux';
import I18n from '../../config/locales';
import { Grid, Box, Typography, Button } from '@material-ui/core';
import { localeMoment as moment } from '../../components/common/moment';
import { withStyles } from '@material-ui/core/styles';
import {
  ScoreCardPanel,
  AccountDetails,
  Announcements,
  Support,
  Systems,
  EINInvitation,
  IndustryNews2,
  ImageBanner,
  Pronto
} from '../../components/Dashboard';
import { accountLists, benefitsList } from 'enlm_ui_common';
import { clearMesage } from '../Layouts/actions';
import { getNpsRatings } from '../EinDashboard/actions';
import Loader from '../../components/Loader';
import { get, isEqual, isEmpty, findIndex } from '../../utils/lodash';
import {
  getAllSystemList,
  getAllDashboardList,
  getAllActivationList,
  getAllAlertList,
  getSearchData,
  resetSearchData,
  getEnlmFeedback,
  getSystemSavedSearch,
  getFilteredList,
  getServiceManagerCases
} from './actions';
import { getLeads } from '../LeadManagement/actions';
import { updateUserPreferences } from '../Preferences/actions';
import { getLeadStateName } from '../LeadManagement/helper';
import settings from '../../utils/settings';
import analytics from '../../utils/analytics';
import feature from '../../utils/feature';
import { npsScoreNumber } from '../../components/NpsDashboard/helper';
import SwitchToClassicUIPopup from '../../components/Dashboard/SwitchToClassicUIPopup';
import SystemsForMobile from '../../components/Dashboard/TableForMobile';
import { isCompanyIdValid } from '../../utils/helper';
import ServiceManagerCases from '../../components/Dashboard/ServiceManagerCases';
import { getProntoProviderStatus, getInstallerInfo } from '../../containers/Pronto/actions';
import PerformanceAnalytics from '../../utils/GoogleAnalytics/performanceAnalytics'
// import BomDialog from '../../components/Commercial/BomDialog';

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    backgroundColor: theme.palette.background.paper,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  accountWrapper: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
    gridColumnGap: theme.spacing(3),
    gridRowGap: theme.spacing(1.5),
    marginTop: theme.spacing(0.5),
    [theme.breakpoints.down('xs')]: {
      display: 'block'
    }
  },
  pageHeader: {
    marginBottom: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap'
    }
  },
  widgetWrapper: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },
  supportNews: {
    marginLeft: 'auto',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0
    },
    width: '38%',
    minWidth: '38%',
    [theme.breakpoints.down('sm')]: {
      minWidth: 'auto',
      width: '100%',
      marginLeft: theme.spacing(0)
    }
  },
  logoWrapper: {
    padding: theme.spacing(1),
    borderRadius: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'center',
    background: '#FFF',
    overflow: 'auto',
    textAlign: 'center',
    minWidth: theme.spacing(12.5),
    marginRight: theme.spacing(2),
    width: theme.spacing(15),
    height: theme.spacing(12.5),
    [theme.breakpoints.down('xs')]: {
      flexBasis: '20%',
      width: theme.spacing(12.5),
      height: theme.spacing(7.5),
      marginRight: 0
    }
  },
  logo: {
    maxWidth: theme.spacing(12.5),
    maxHeight: theme.spacing(12.5),
    verticalAlign: 'middle',
    margin: 'auto'
  },
  companyName: {
    fontSize: 35,
    fontWeight: 'bold',
    color: '#335977',
    margin: theme.spacing(0)
  },
  switchButton: {
    display: 'flex',
    marginLeft: 'auto',
    [theme.breakpoints.down('xs')]: {
      flexBasis: '55%',
      textTransform: 'initial',
      fontSize: 12,
      maxWidth: theme.spacing(25)
    }
  }
});

class index extends Component {
  constructor(props) {
    super(props);
    this.timeout = null;
    this.analytics = new analytics();
    this.ENLMPerformance = new PerformanceAnalytics()
    this.state = {
      isExtraSmall: window.innerWidth <= 550,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      isNpsUpdated: false,
      showSwitchToClassicUIPopup: false,
      is_flag_changed: false
      // openBomDialog: false
    };
    this.isNpsUpdated = false;
    this.accountListsData = accountLists;
    this.benefitsListData = benefitsList;
    this.isProntoEnabled = false;
    this.dashboadLoadTimeReported = false;
    const REGEXFILTERS = {
      autocompleteapi: new RegExp("api_internal/sites/autocomplete", 'i'),
      account_api: new RegExp("api_internal/account", "i"),
      companyinfo_api: new RegExp("api_internal/company/"),
      pronto_api: new RegExp("pronto_integration_ms/"),
      healthcheck_api: new RegExp("healthcheck"),
      dashboardlist_api: new RegExp("api_internal/sites/")
    }
    this.apiPerformanceObserver = new PerformanceObserver((entries) => {
      entries.getEntries().forEach((entry) => {
        if (entry.entryType === "resource") {

          const modifiedEntry = this.ENLMPerformance.processResourceEntry(entry)
          let resourceName = new URL(entry.name)
          if(REGEXFILTERS.dashboardlist_api.test(resourceName.pathname)){
            if (entry.name.includes('dashboard_list')) {
              modifiedEntry.name = 'ENLM_DASHBOARDLIST_API'
            }
          }
          else if (REGEXFILTERS.autocompleteapi.test(resourceName.pathname)) {
            if (entry.name.includes('all')) {
              modifiedEntry.name = 'ENLM_AUTOCOMPLETE_ALL_API'
            }
            else if (entry.name.includes('alert')) {
              modifiedEntry.name = 'ENLM_AUTOCOMPLETE_ALERT_API'
            }
            else if (entry.name.includes('activation')) {
              modifiedEntry.name = 'ENLM_AUTOCOMPLETE_ACTIVATION_API'
            }
          }
          else if (REGEXFILTERS.account_api.test(resourceName.pathname)) {
            if (entry.name.endsWith('/account')) {
              modifiedEntry.name = 'ENLM_ACCOUNT_API'
            }
            else if (entry.name.includes("fleet_dashboard_url")) {
              modifiedEntry.name = 'ENLM_FLEET_TOKEN_API'
            }
            else if (entry.name.endsWith("/data")) {
              modifiedEntry.name = 'ENLM_BANNER_DATA_API'
            }
            else if (entry.name.includes("ab_features")) {
              modifiedEntry.name = 'ENLM_AB_FEATURES_API'
            }
            else if (entry.name.includes("system_groups_and_saved_searches")) {
              modifiedEntry.name = 'ENLM_SYSTEM_GROUPS_SAVED_SEARCHES_API'
            }
            else if (entry.name.includes("training_dashboard_token")) {
              modifiedEntry.name = 'ENLM_TRAINING_DASHBOARD_TOKEN_API'
            }
          }
          else if (REGEXFILTERS.companyinfo_api.test(resourceName.pathname)) {
            modifiedEntry.name = 'ENLM_COMPANY_API'
          }
          else if (REGEXFILTERS.pronto_api.test(resourceName.pathname)) {
            if (entry.name.endsWith('/installer_info')) {
              modifiedEntry.name = 'ENLM_PRONTO_INSTALLER_INFO_API'
            }
          }
          else if (REGEXFILTERS.healthcheck_api.test(resourceName.pathname)) {
            if (entry.name.endsWith('/healthcheck')) {
              modifiedEntry.name = 'ENLM_HEALTH_CHECK_API'
            }
          }
          if (modifiedEntry.name) {
            this.ENLMPerformance.reportEntry(modifiedEntry)
          }
        }
      })
    })
    // eslint-disable-next-line no-unused-expressions
    this.apiPerformanceObserver?.observe({ entryTypes: ["resource"] })
  }

  componentDidMount() {
    this.ENLMPerformance.mark('DASHBOARD_MOUNTED')
    const { companyId, getSystemSavedSearch, fromITK, accountData } = this.props;
    this.props.clearMesage();
    // this.props.getAllSystemList({});
    this.props.getAllDashboardList({});
    if (!fromITK) {
      // this.props.getAllActivationList({});
      // this.props.getAllAlertList({});
    }
    isCompanyIdValid(companyId) && this.props.getLeads({ companyId, pageNum: 0, recordCount: 25, criteria: 'active' });
    this.props.getEnlmFeedback();
    isCompanyIdValid(companyId) && this.props.getServiceManagerCases();
    getSystemSavedSearch();
    window.addEventListener('resize', this.handleWindowSizeWindow);

  }

  componentDidUpdate() {
    if (feature.isFeatureEnabled("PRONTO_INSTALLER") &&
      !this.is_flag_changed &&
      window.build_environment !== "preprod" &&
      window.build_environment !== "qa4") {
      this.props.getInstallerInfo();
      this.is_flag_changed = true;
    }
    const { featureList } = this.props;
    const hasEinDashboard = !isEmpty(featureList) ? feature.isFeatureEnabled('EIN_DASHBOARD') : false;
    if (!this.state.isNpsUpdated && !isEmpty(featureList)) {
      if (hasEinDashboard) {
        this.props.getNpsRatings();
        this.setState({ isNpsUpdated: true });
      } else {
        this.setState({ isNpsUpdated: true });
      }
    }
    // this.isProntoEnabled =
    //   (feature.isFeatureEnabled("PRONTO_INSTALLER") &&
    //     this.props.isUsInstallerAdmin &&
    //     window.build_environment !== "preprod" &&
    //     window.build_environment !== "qa4") ||
    //   false;
    // console.log("isProntoEnabled ", this.isProntoEnabled)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeWindow);
    // eslint-disable-next-line no-unused-expressions
    this.apiPerformanceObserver?.disconnect();
  }

  handleWindowSizeWindow = () => {
    const isExtraSmall = window.innerWidth <= 550;
    if (isExtraSmall !== this.state.isExtraSmall) {
      this.setState({ isExtraSmall });
    }
    this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
  };

  getLeadList = (leads, totalNewLeads, totalLeads) => {
    const leadData = leads.map(lead => {
      const firstName = lead.first_name || '-';
      const lastName = lead.last_name || '-';
      let fullName = `${firstName} ${lastName}`;
      if (lead.current_state.state_id === 1) {
        fullName = 'New Lead';
      }
      return {
        id: lead.lead_id,
        name: fullName,
        status_text: getLeadStateName(get(lead, 'current_state.state_id'), lead) || get(lead, 'current_state.state'),
        status_id: get(lead, 'current_state.state_id'),
        no_lead_expiry: get(lead, 'no_lead_expiry'),
        expires_in: get(lead, 'expires_in'),
        city: (lead && lead.address && lead.address.city) || '',
        state: (lead && lead.address && lead.address.state) || '',
        created_at: lead.created_time,
        journey_type: lead.journey_type,
        is_active: get(lead, 'is_active', true),
        lead_source: get(lead, 'lead_source', '')
      };
    });
    return {
      totalNewLeads,
      result: leadData,
      totalLeads: totalLeads
    };
  };

  getSearchType = searchType => {
    switch (searchType) {
      case 'all':
      case 'All':
        return 'all';
      case 'alert':
      case 'Alerts':
        return 'alert';
      case 'activation':
      case 'Activations':
        return 'activation';
      default:
        return 'all';
    }
  };

  getSearchResult = (searchValue, searchType) => {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.props.getSearchData({
        searchValue: searchValue || '_ALL_SITES_',
        searchType: this.getSearchType(searchType)
      });
    }, 1000);
  };

  toggleSwitchToClassicUIPopup = (proceed = false) => {
    this.setState({ showSwitchToClassicUIPopup: !this.state.showSwitchToClassicUIPopup });
    if (proceed) {
      this.switchToClassicView();
    }
  };

  handleSwitchToClassicView = () => {
    if (!isEmpty(this.props.enlmFeedbacks)) {
      this.switchToClassicView();
    } else {
      this.toggleSwitchToClassicUIPopup();
    }
  };

  switchToClassicView = () => {
    const { companyId } = this.props;
    const data = {
      company_id: companyId,
      preferred_new_dashboard_view: false
    };
    this.props.updateUserPreferences({
      companyId,
      body: { account: data },
      successCbk: () => {
        this.analytics.triggerEvent({ event: 'triggerSwitchToClassic' }, {});
        window.location = settings.enlightenMenuUrl('dashboard/old_view');
      }
    });
  };

  getNpsScore = () => {
    const { ratings } = this.props;
    const { ratingsList = [] } = ratings;
    const zeroToTenRatings = {
      zeroRatingsCount: get(ratingsList, '0', 0),
      oneRatingsCount: get(ratingsList, '1', 0),
      twoRatingsCount: get(ratingsList, '2', 0),
      threeRatingsCount: get(ratingsList, '3', 0),
      fourRatingsCount: get(ratingsList, '4', 0),
      fiveRatingsCount: get(ratingsList, '5', 0),
      sixRatingsCount: get(ratingsList, '6', 0),
      sevenRatingsCount: get(ratingsList, '7', 0),
      eightRatingsCount: get(ratingsList, '8', 0),
      nineRatingsCount: get(ratingsList, '9', 0),
      tenRatingsCount: get(ratingsList, '10', 0)
    };
    return npsScoreNumber(zeroToTenRatings, ratingsList);
  };

  preprod_check = (disableGeneratorToken = false) => {
    if (disableGeneratorToken && window.build_environment === 'preprod') {
      return true;
    }
    return false;
  };

  refreshProntoStatus = () => {
    this.props.getProntoProviderStatus()
  }
  checkIfInstallerAdmin = () => {
    const accountRoles = this.props.accountData ? (this.props.accountData.roles ? this.props.accountData.roles : []) : [];
    // console.log("accountRoles:", accountRoles)
    const isInstallerAccount = this.props.accountData ? (this.props.accountData.is_installer_account ? this.props.accountData.is_installer_account : false) : false;
    // console.log("is Installer:", isInstallerAccount)
    if (accountRoles.includes("admin") && isInstallerAccount) {
      return true
    }
    return false
  }
  render() {
    const {
      classes,
      companyId,
      companyInfo,
      dashboardLinks,
      company,
      currentlySending,
      accountData,
      accountLoading,
      systemList,
      dashboardList,
      activationList,
      alertList,
      searchList,
      leads,
      totalLeads,
      totalNewLeads,
      bannerNotice,
      imageBanner,
      preferencesData,
      leadsLoading,
      systemLoading,
      activationLoading,
      dashboardLoading,
      alertLoading,
      belongsToAus,
      enlightenManagerToken,
      belongsToUs,
      fromIFrame,
      featureList,
      countryCode,
      companyName: company_name,
      logoUrl,
      companyState,
      einOptIn,
      einOptOut,
      installingSince,
      sitesCount,
      storagesCount,
      microinvertersCount,
      companyTier,
      ensembleTraining,
      solarInstallCertification,
      systemSavedSearch,
      getFilteredList,
      viewOnlyAccess,
      isHomeowner,
      locale,
      viewCannotEdit,
      fromITK
    } = this.props;
    const pronto_ab_enabled = feature.isFeatureEnabled('PRONTO_INSTALLER') || false;
    const displayPronto =
      (pronto_ab_enabled &&
        this.props.isUsInstallerAdmin &&
        window.build_environment !== "preprod" &&
        window.build_environment !== "qa4") ||
      false;
    const isLoading = accountLoading || currentlySending;
    const preprod_check = this.preprod_check(true);
    const systemLoadingProps = { systemLoading, activationLoading, alertLoading };
    if (isLoading) return <Loader loading={isLoading} />;
    const { nps, ein_opt_in, ein_opt_out } = companyInfo;
    const hasEinDashboard = !isEmpty(featureList) ? feature.isFeatureEnabled('EIN_DASHBOARD') : false;
    const npsScore = this.state.isNpsUpdated ? (hasEinDashboard ? this.getNpsScore() : nps) : '';
    const isAdministrator = accountData && accountData.roles && accountData.roles.includes('admin');
    const companyName = get(company, 'name') || company_name || '';
    const companyLogo = get(company, 'logo_img_url') || logoUrl || '';
    const country = get(company, 'address.country') || countryCode || '';
    const state = get(company, 'address.state') || companyState || '';
    const leadOptIn = feature.isFeatureEnabled('LEAD_OPT_IN') || false;
    const abEinOptIn = feature.isFeatureEnabled('EIN_OPT_IN') || false;
    const abLreEnabled = feature.isFeatureEnabled('LRE_ENABLED') || false;
    const abPermitEnabled = feature.isFeatureEnabled('PERMIT_ENABLED') || false;
    const abBOMEnabled = feature.isFeatureEnabled('BOM_CALCULATOR') || false;
    const abSgipEnabled = feature.isFeatureEnabled('INCENTIVE_PROGRAM') || false;
    const abEinMerchandise = feature.isFeatureEnabled('EIN_MERCHANDISE') || false;
    const isAuthorizedSubcontractor = feature.isFeatureEnabled('AUTHORIZED_SUBCONTRACTOR') || false;
    // const generatorTokensEnabled = false;
    const generatorTokensEnabled = !preprod_check
      ? accountData?.is_installer_account || accountData?.is_distributor
        ? feature.isFeatureEnabled("GENERATOR_TOKENS") || false
        : false
      : false;
    const dataPlanExtensionEnabled = !preprod_check
      ? accountData?.is_installer_account || accountData?.is_distributor
        ? feature.isFeatureEnabled("CELLMODEM_DATA_PLAN_EXTENSION") || false
        : false
      : false;
    const hasTier = !!(companyInfo && companyInfo.tier && companyInfo.tier.name);
    const isUSA = country && country.toLowerCase() === 'us';
    const benefitsIndex = findIndex(this.accountListsData, account => account.key === 'benefits');
    if (isUSA && benefitsIndex < 0) {
      this.accountListsData.splice(2, 0, this.benefitsListData);
    }
    const isUser = accountData && accountData.roles && isEqual(accountData.roles, []) === true;
    const isDemo =
      (accountData && accountData.roles && accountData.roles.includes('demo')) || (viewOnlyAccess && !viewCannotEdit);
    if (isUser) {
      const companyIndex = findIndex(this.accountListsData, account => account.key === 'account_information');
      companyIndex > -1 && this.accountListsData.splice(companyIndex, 1);
    }
    const scoreCardDetails = {
      tier: companyTier,
      show_ein_learn_more_link: get(dashboardLinks, 'ein.show_link', false),
      installingSince: (installingSince && moment(installingSince).format('DD-MMM-YY')) || '',
      ensembleCertification: ensembleTraining ? I18n.t('dashboard.yes') : I18n.t('dashboard.no'),
      npsScore,
      sitesCount,
      invertersCount: microinvertersCount,
      storagesCount,
      solarInstallCertification: solarInstallCertification ? I18n.t('dashboard.yes') : I18n.t('dashboard.no'),
      belongsToUs,
      belongsToAus,
      isAdministrator,
      featureList,
      isUserDemoRole: isUser || isDemo,
      showEinBadge: ein_opt_in || einOptIn
    };
    const leadList = this.getLeadList(leads, totalNewLeads, totalLeads);
    const pageTitle = companyName ? companyName : I18n.t('dashboard.title');
    const pageHeader = (
      <Box className={classes.pageHeader}>
        {companyName &&
          companyLogo &&
          companyLogo !== '' &&
          companyLogo !== '/logo_imgs/og/missing.png' && (
            <Box className={classes.logoWrapper}>
              <img alt="company logo" src={companyLogo} className={classes.logo} />
            </Box>
          )}
        {!this.state.isExtraSmall && <Typography className={classes.companyName}>{pageTitle}</Typography>}
        {preferencesData.preferred_new_dashboard_view &&
          !fromITK && (
            <Button
              className={classes.switchButton}
              variant="outlined"
              color="primary"
              size="small"
              onClick={this.handleSwitchToClassicView}
              id="switchToClassicButton"
            >
              {I18n.t('dashboard.switchToClassic')}
            </Button>
          )}
        {this.state.isExtraSmall && <Typography className={classes.companyName}>{pageTitle}</Typography>}
      </Box>
    );

    if (isLoading === false && !dashboardLoading  && !this.dashboadLoadTimeReported) {
      try {
        this.dashboadLoadTimeReported = true
        let performanceEntry = this.ENLMPerformance.measure('DASHBOARD_LOAD_TIME', `DASHBOARD_MOUNTED`)
        this.ENLMPerformance.reportMeasure(performanceEntry, 300)
        this.ENLMPerformance.clearMeasures('DASHBOARD_LOAD_TIME')
        this.ENLMPerformance.clearMarks(`DASHBOARD_MOUNTED`)
      } catch (error) {
        console.warn("[PERFORMANCE] ", `DASHBOARD_MOUNTED`, "mark not found")
      }
    }
    return (
      <div className={classes.root}>
        {pageHeader}
        <ScoreCardPanel {...scoreCardDetails} npsScoreUpdated={this.state.isNpsUpdated} />
        {!(ein_opt_in || einOptIn) && abEinOptIn ? (
          <React.Fragment>
            <br />
            <EINInvitation hasTier={hasTier} isUser={isUser} />
          </React.Fragment>
        ) : null}
        {!isEmpty(bannerNotice) && !fromIFrame && <Announcements bannerNotice={bannerNotice} />}
        {!isEmpty(imageBanner) && !fromIFrame && <ImageBanner imageBanner={imageBanner} />}
        <Box className={classes.widgetWrapper}>
          {this.state.windowWidth <= 1100 ? (
            <SystemsForMobile
              systemList={systemList}
              dashboardList={dashboardList}
              activationList={activationList}
              alertList={alertList}
              leadList={leadList}
              searchList={searchList}
              getSearchResult={this.getSearchResult}
              companyId={companyId}
              systemSavedSearch={systemSavedSearch}
              getFilteredList={getFilteredList}
              getLeads={this.props.getLeads}
              leadOptIn={true}
              fromITK={fromITK}
              systemLoadingProps={systemLoadingProps}
            />
          ) : (
            <Systems
              dashboardList={dashboardList}
              activationList={activationList}
              alertList={alertList}
              leadList={leadList}
              leadOptIn={leadOptIn}
              searchList={searchList}
              getSearchResult={this.getSearchResult}
              resetSearchData={this.props.resetSearchData}
              leadsLoading={leadsLoading}
              companyId={companyId}
              windowWidth={this.state.windowWidth}
              systemSavedSearch={systemSavedSearch}
              getFilteredList={getFilteredList}
              getLeads={this.props.getLeads}
              fromITK={fromITK}
              systemLoadingProps={systemLoadingProps}
              accountData={accountData}
            />
          )}
          <Box className={classes.supportNews}>
            <ServiceManagerCases />
            <Support accountData={accountData} />
            {displayPronto && <Pronto accountData={accountData} refreshProntoStatus={this.refreshProntoStatus}></Pronto>}
          </Box>
        </Box>

        {!isDemo && (
          <Grid className={classes.accountWrapper}>
            {this.accountListsData.map(
              (accountList, index) =>
                accountList.title !== 'benefits' ? (
                  <AccountDetails
                    key={index}
                    companyId={companyId}
                    accountList={accountList}
                    leadOptIn={leadOptIn}
                    abLreEnabled={abLreEnabled}
                    abPermitEnabled={abPermitEnabled}
                    abBOMEnabled={abBOMEnabled}
                    abSgipEnabled={abSgipEnabled}
                    abEinMerchandise={abEinMerchandise}
                    state={state}
                    enlightenManagerToken={enlightenManagerToken}
                    einOptIn={ein_opt_in || einOptIn}
                    einOptOut={ein_opt_out || einOptOut}
                    hasTier={hasTier}
                    viewOnlyAccess={viewOnlyAccess}
                    companyInfo={companyInfo}
                    dashboardLinks={dashboardLinks}
                    accountData={accountData}
                    featureList={featureList}
                    countryCode={countryCode}
                    locale={locale}
                    isAuthorizedSubcontractor={isAuthorizedSubcontractor}
                    generatorTokensEnabled={generatorTokensEnabled}
                    dataPlanExtensionEnabled={dataPlanExtensionEnabled}
                  // showBomDialog={() => this.setState({ openBomDialog: true })}
                  />
                ) : (
                  ''
                )
            )}
          </Grid>
        )}

        {belongsToUs && (
          <Box>
            <IndustryNews2 />
          </Box>
        )}
        
        <SwitchToClassicUIPopup
          open={this.state.showSwitchToClassicUIPopup}
          handleClose={this.toggleSwitchToClassicUIPopup}
          handleSave={e => this.toggleSwitchToClassicUIPopup(true)}
          windowWidth={this.state.windowWidth}
          windowHeight={this.state.windowHeight}
        />
        {/* {this.state.openBomDialog && (
          <BomDialog
            open={this.state.openBomDialog}
            onDialogClose={() => this.setState({ openBomDialog: false })}
            url={`/manager/dashboard/${companyId}/leads?from=bom-dialog`}
          />
        )} */}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  clearMesage: () => dispatch(clearMesage()),
  getAllSystemList: payload => dispatch(getAllSystemList(payload)),
  getAllDashboardList: payload => dispatch(getAllDashboardList(payload)),
  getAllActivationList: payload => dispatch(getAllActivationList(payload)),
  getAllAlertList: payload => dispatch(getAllAlertList(payload)),
  getLeads: payload => dispatch(getLeads(payload)),
  getSearchData: payload => dispatch(getSearchData(payload)),
  resetSearchData: () => dispatch(resetSearchData()),
  updateUserPreferences: payload => dispatch(updateUserPreferences(payload)),
  getNpsRatings: () => dispatch(getNpsRatings()),
  getEnlmFeedback: () => dispatch(getEnlmFeedback()),
  getSystemSavedSearch: () => dispatch(getSystemSavedSearch()),
  getFilteredList: payload => dispatch(getFilteredList(payload)),
  getServiceManagerCases: () => dispatch(getServiceManagerCases()),
  getProntoProviderStatus: () => dispatch(getProntoProviderStatus()),
  getInstallerInfo: () => dispatch(getInstallerInfo())
});

const mapStateToProps = state => ({
  companyId: state.appReducer.companyId,
  company: state.appReducer.company,
  companyInfo: state.appReducer.companyInfo,
  dashboardLinks: state.appReducer.dashboardLinks,
  currentlySending: state.appReducer.currentlySending,
  accountLoading: state.accountReducer.currentlySending,
  accountData: state.accountReducer.accountDetail,
  systemList: state.dashboardReducer.systemList,
  activationList: state.dashboardReducer.activationList,
  alertList: state.dashboardReducer.alertList,
  searchList: state.dashboardReducer.searchList,
  dashboardList: state.dashboardReducer.dashboardList,
  dashboardLoading: state.dashboardReducer.dashboardLoading,
  systemLoading: state.dashboardReducer.systemLoading,
  activationLoading: state.dashboardReducer.activationLoading,
  alertLoading: state.dashboardReducer.alertLoading,
  leads: state.leadReducer.leads,
  totalLeads: state.leadReducer.totalElements,
  totalNewLeads: state.leadReducer.totalNewLeads,
  leadsLoading: state.leadReducer.currentlySending,
  bannerNotice: state.appReducer.bannerNotice,
  imageBanner: state.appReducer.imageBanner,
  preferencesData: state.preferencesReducer.preferencesData,
  belongsToAus: state.appReducer.belongsToAus,
  enlightenManagerToken: state.appReducer.enlightenManagerToken,
  belongsToUs: state.appReducer.belongsToUs,
  featureList: state.appReducer.featureList,
  countryCode: state.appReducer.countryCode,
  companyName: state.appReducer.companyName,
  logoUrl: state.appReducer.logoUrl,
  companyState: state.appReducer.companyState,
  einOptIn: state.appReducer.einOptIn,
  einOptOut: state.appReducer.einOptOut,
  ratings: state.einDashboardReducer.ratings,
  installingSince: state.appReducer.installingSince,
  sitesCount: state.appReducer.sitesCount,
  storagesCount: state.appReducer.storagesCount,
  microinvertersCount: state.appReducer.microinvertersCount,
  companyTier: state.appReducer.companyTier,
  ensembleTraining: state.appReducer.ensembleTraining,
  solarInstallCertification: state.appReducer.solarInstallCertification,
  enlmFeedbacks: state.dashboardReducer.enlmFeedbacks,
  systemSavedSearch: state.dashboardReducer.systemSavedSearch,
  viewOnlyAccess: state.accountReducer.viewOnlyAccess,
  isHomeowner: state.accountReducer.isHomeowner,
  locale: state.accountReducer.locale,
  viewCannotEdit: state.accountReducer.viewCannotEdit,
  fromITK: state.appReducer.fromITK,
  isUsInstallerAdmin: state.prontoReducer.isUsInstallerAdmin
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(index));
